<template>
  <div class="flex flex-col">
    <!-- ADD COMMENT -->
    <section class="flex-auto w-full px-4 pt-8 text-left">
      <h2 class="font-semibold text-gray-500 dark:text-gray-400 mb-2 text-left select-none">
        Add Comment
      </h2>
      <div class="w-full mb-8">
        <textarea
          v-model="comment"
          @change="addComment"
          rows="3"
          class="w-full border border-gray-300 dark:border-gray-800 rounded p-2 transition-all focus:ring-1 focus:ring-primary focus:border focus:border-primary"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from "vuex"

export default {
  name: "WorkOrderSubmitPrompt",
  data() {
    return {
      comment: null
    }
  },
  methods: {
    ...mapMutations(["setProceedArgs", "setPromptComment"]),
    addComment() {
      console.log(this.comment)
      this.setPromptComment(this.comment)
    }
  },
}
</script>